module.exports = __webpack_public_path__ + "img/svgHolder.7bf9e981.svg";